var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col"},[_c('Header'),_c('v-main',{staticClass:"grow dark:bg-fox-900"},[_c('router-view')],1),_c('Footer'),(_vm.isLoading)?_c('div',{staticClass:"loading-holder"},[_c('Loading')],1):_vm._e(),_c('Script',{attrs:{"src":"https://www.google.com/recaptcha/api.js","async":"","defer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }